import {
    Box,
    Button,
    Tooltip,
    useToken,
} from '@chakra-ui/react';
import { forwardRef } from 'react';
import { ServiceIcon } from './service-icon';

function ServiceButtonRefFunction({
    service,
    tooltipLabel,
    isError = false,
    ...rest
}: {
    service: {
        complianceServiceId: number;
        name: string;
    };
    tooltipLabel?: string;
    isError?: boolean;
}, ref: React.ForwardedRef<HTMLInputElement>) {
    const accent = useToken('colors', isError ? 'danger.500' : 'muted.50');
    const serviceIconColor = useToken('colors', isError ? 'danger.500' : 'primary.500');
    const bgColor = useToken('colors', isError ? 'danger.50' : 'white');

    return (
        <Tooltip
            hasArrow
            label={tooltipLabel}
            fontSize="xs"
            bg="charcoal.500"
        >
            <Button
                ref={ref}
                as={Box}
                aria-label="Service Icon Button"
                key={service.complianceServiceId}
                size="md"
                px={1}
                color="charcoal.900"
                fontWeight="normal"
                variant="outline"
                colorScheme="muted"
                borderColor={accent}
                bgColor={bgColor}
                _hover={{ bgColor }}
                iconSpacing={0}
                leftIcon={(
                    <ServiceIcon
                        height="22px"
                        service={service.name}
                        fill={serviceIconColor}
                    />
                )}
                {...rest}
            />
        </Tooltip>

    );
}

export const ServiceButton = forwardRef(ServiceButtonRefFunction);
